import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const HOUSEKEEPING_VENDOR_FIELDS = [
  {
    question: VENDORS.HOUSEKEEPING_SUPPLIES_VENDOR,
    title: 'Housekeeping supplies',
    invoiceFileTypeId: FILE_TYPES.HOUSEKEEPING_SUPPLIES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.HOUSEKEEPING_SUPPLIES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.HOUSEKEEPING_CHEMICALS_VENDOR,
    title: 'Housekeeping chemicals',
    invoiceFileTypeId: FILE_TYPES.HOUSEKEEPING_CHEMICALS_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.HOUSEKEEPING_CHEMICALS_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY,
    title: 'Housekeeping and laundry outsourced company',
    invoiceFileTypeId: FILE_TYPES.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.LINEN_SUPPLIER_VENDOR,
    title: 'Linen supplier vendor',
    invoiceFileTypeId: FILE_TYPES.LINEN_SUPPLIER_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.LINEN_SUPPLIER_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.HOUSEKEEPING_EQUIPMENT_RENTAL_VENDOR,
    title: 'Housekeeping equipment rental vendor',
    invoiceFileTypeId: FILE_TYPES.HOUSEKEEPING_EQUIPMENT_RENTAL_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.HOUSEKEEPING_EQUIPMENT_RENTAL_VENDOR_CONTRACT,
  },
];
